import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { getPlatformConfig } from '../../../constants/platformLogos';
import { ExternalLink, RefreshCw, Trash2 } from 'lucide-react';

const formatDate = (date) => {
  if (!date) return 'N/A';
  return new Date(date)?.toLocaleDateString();
};

const SocialAccountCard = ({ account, onDisconnect, onSync }) => {
  const platformConfig = getPlatformConfig(account?.platform?.toLowerCase());

  const getStatusColor = (status) => {
    // ... existing code ...
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 hover:border-primary/50 transition-colors">
      <div className="flex items-start gap-4">
        <div 
          className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 p-2"
          style={{ backgroundColor: `${platformConfig?.color}15` }}
        >
          {platformConfig ? (
            <Image 
              src={platformConfig?.logo}
              alt={platformConfig?.alt}
              className="w-full h-full object-contain"
              style={{ filter: `drop-shadow(0 0 2px ${platformConfig?.color}40)` }}
            />
          ) : (
            <Icon name="Globe" size={24} className="text-muted-foreground" />
          )}
        </div>

        <div className="flex items-center gap-3">
          <div>
            <h3 className="font-semibold text-gray-900 capitalize">{account?.platform}</h3>
            <p className="text-sm text-gray-600">{account?.accountName}</p>
          </div>
          <div className={`px-2 py-1 rounded-full text-xs font-medium ${account?.isConnected ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
            {account?.isConnected ? 'Connected' : 'Disconnected'}
          </div>
        </div>
      </div>
      {account?.accountUrl && (
        <a
          href={account?.accountUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-700 text-sm flex items-center gap-1 mb-3"
        >
          <ExternalLink className="w-3 h-3" />
          View Profile
        </a>
      )}
      <div className="space-y-2 mb-4">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Followers:</span>
          <span className="font-semibold text-gray-900">{account?.followerCount?.toLocaleString()}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Last Synced:</span>
          <span className="text-gray-900">{formatDate(account?.lastSyncedAt)}</span>
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          onClick={() => onSync(account?.id)}
          variant="outline"
          size="sm"
          className="flex-1 flex items-center justify-center gap-2"
        >
          <RefreshCw className="w-4 h-4" />
          Sync
        </Button>
        <Button
          onClick={() => onDisconnect(account?.id)}
          variant="outline"
          size="sm"
          className="text-red-600 hover:text-red-700 flex items-center gap-2"
        >
          <Trash2 className="w-4 h-4" />
          Remove
        </Button>
      </div>
    </div>
  );
};

export default SocialAccountCard;